module.exports = __webpack_public_path__ + "img/family.436e63d9.jpg";